<h2 mat-dialog-title>AOPA Airport Directory Fuel Price Map</h2>
<mat-dialog-content class="mat-typography">
  <p>To view fuel prices in a region, enter an airport identifier, airport name, city or state. To ensure location
    accuracy, select the matching choice in the drop-down results list before tapping the Search button.</p>

  <p>Opening the map will initially display the selected fuel type prices within a 50-mile radius when searching for
    an airport or city. When searching for a state, the map is centered on the entire state and all fuel prices for the
    state are shown. Zooming in/out or panning the map will display more fuel prices.</p>

  <p>Fuel prices are grouped in thirds based on relative price to others that are currently displayed on the map.
    Green prices represent the lowest third, red prices represent the highest third and yellow prices are the middle
    group. Color assignments are re-evaluated when zooming in/out or panning the map as more or less prices are
    displayed. This may cause the color assignments to change.</p>
</mat-dialog-content>
<mat-dialog-actions align="end">
  <button class="mat-raised-button submit-button" mat-button cdkFocusInitial (click)="dismiss()">Close</button>
</mat-dialog-actions>
